/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Snackbar,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES, CODE_QUANGNAM, MenuProps } from "../../utils/constants";
import FormHoiDong from "./formHoiDong";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };
const OPTION_ROLE = [
  {
    ma: "province",
    ten: "Cấp phường/xã",
  },
  {
    ma: "district",
    ten: "Cấp quận huyện",
  },
  {
    ma: "subDistrict",
    ten: "Cấp tỉnh",
  },
];

const roleNumber = {
  province: 1,
  district: 2,
  subDistrict: 3,
};

const DICT_ROLE = {
  1: "Cấp phường/xã",
  2: "Cấp huyện",
  3: "Cấp tỉnh",
};

const TYPE_HOIDONG = [
  {
    ma: "1",
    ten: "Hội đồng",
  },
  {
    ma: "2",
    ten: "Tổ tư vấn",
  },
  {
    ma: "3",
    ten: "Tổ thư ký Hội đồng",
  },
];

function HoiDong() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [roleState, setRoleState] = useState(ALLVALUE.ma);
  const [loaiState, setLoaiState] = useState(ALLVALUE.ma);
  const [districtState, setDistrictState] = useState(ALLVALUE.ma);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionMember, setOptionMember] = useState([]);

  const handleChangeRole = (e) => {
    let { value } = e.target;
    setRoleState(value);
  };

  const handleChangeLoai = (e) => {
    let { value } = e.target;
    setLoaiState(value);
  };

  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setDistrictState(value);
  };

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.HOIDONG + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      fetchData(roleState, loaiState, districtState, pagination);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      // setTableData([...tableData]);
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.HOIDONG + "/" + values.id,
          { ...values }
        );
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(API_ROUTES.HOIDONG, {
          ...values,
        });
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      fetchData(roleState, loaiState, districtState, pagination);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };

  // Lấy toàn bộ dữ liệu theo năm, tỉnh, huyện, loại doanh nghiêp, cấp quản lý
  const fetchData = async (role, loai, district, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        capquanly: role == ALLVALUE.ma ? undefined : roleNumber[role],
        loai: loai == ALLVALUE.ma ? undefined : loai,
        maquan: district == ALLVALUE.ma ? undefined : district,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.HOIDONG, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(roleState, loaiState, districtState, pagination);
  }, [roleState, loaiState, districtState, pagination]);

  useEffect(() => {
    const fetchDataHuyen = async (codeProvince) => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: { tinh: codeProvince },
        });
        let list = [{ ma: "", ten: "Tỉnh Quảng Nam" }, ...response?.data];
        setOptionDistrict(list);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataThanhVien = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.THANHVIEN);
        setOptionMember(response?.data?.data);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    fetchDataHuyen(CODE_QUANGNAM);
    fetchDataThanhVien();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "soquyetdinh",
        header: "Số quyết định",
        size: 150,
      },
      {
        accessorKey: "ngayky",
        header: "Ngày ký",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY")
            : value;
        },
      },
      {
        accessorKey: "capquanly",
        header: "Cấp quản lý",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return DICT_ROLE[value] ? DICT_ROLE[value] : value;
        },
      },
      {
        accessorKey: "trichyeu",
        header: "Trích yếu",
        size: 250,
      },
    ],
    []
  );

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.HOIDONG + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa hội đồng");
    setValidationErrors({});
    setModalOpen(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="label-capquanly">Cấp quản lý</InputLabel>
              <Select
                sx={{ padding: "0.7rem" }}
                labelId="label-capquanly"
                value={roleState ? roleState : ALLVALUE.ma}
                defaultValue={ALLVALUE.ma}
                label="Cấp quản lý"
                MenuProps={MenuProps}
                onChange={handleChangeRole}
              >
                <MenuItem value={ALLVALUE.ma}>Tất cả</MenuItem>
                {OPTION_ROLE &&
                  OPTION_ROLE?.map((item) => (
                    <MenuItem key={item.ma} value={item.ma}>
                      {item.ten}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="label-loai">Loại</InputLabel>
              <Select
                sx={{ padding: "0.7rem" }}
                labelId="label-loai"
                value={loaiState ? loaiState : ALLVALUE.ma}
                defaultValue={ALLVALUE.ma}
                label="Loại"
                MenuProps={MenuProps}
                onChange={handleChangeLoai}
              >
                <MenuItem value={ALLVALUE.ma}>Tất cả</MenuItem>
                {TYPE_HOIDONG &&
                  TYPE_HOIDONG?.map((item) => (
                    <MenuItem key={item.ma} value={item.ma}>
                      {item.ten}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="label-district">Quận/Huyện</InputLabel>
              <Select
                sx={{ padding: "0.7rem" }}
                labelId="label-district"
                value={districtState ? districtState : ALLVALUE.ma}
                defaultValue={ALLVALUE.ma}
                label="Quận/Huyện"
                MenuProps={MenuProps}
                onChange={handleChangeDistrict}
              >
                <MenuItem value={ALLVALUE.ma}>Tất cả</MenuItem>
                {optionDistrict &&
                  optionDistrict?.map((item) => (
                    <MenuItem key={item.ma} value={item.ma}>
                      {item.ten}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 105,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              <Tooltip arrow placement="left" title="Chỉnh sửa">
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Xoá">
                <IconButton
                  color="primary"
                  onClick={() => {
                    let _data = [];
                    _data["id"] = row.getValue("id");
                    _data["soquyetdinh"] = row.getValue("soquyetdinh");
                    handleOpenDeleteConfirmation(_data);
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ color: "#ffffff" }}
                onClick={() => {
                  setAction("New");
                  setTitle("Thêm mới hội đồng");
                  setDataRow({});
                  setValidationErrors({});
                  setModalOpen(true);
                }}
              >
                Tạo mới
              </Button>
            </Stack>
          )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <FormHoiDong
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataThanhVien={optionMember}
          dataHuyen={optionDistrict}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá hội đồng có số quyết định: {selectedRow?.soquyetdinh}{" "}
              này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HoiDong;
